import { ActionCreator } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "./actionTypes";
import { GROUP_TYPE } from "../reducers/editingConfiguration.reducer";

export const ConfigurationsActionCreators: {
    [key: string]: ActionCreator;
} = {
    getConfigurationsList: ({ page = 0, search = null }) => ({
        type: ConfigurationsActionTypes.GET_CONFIGURATIONS_LIST,
        payload: {
            page,
            search
        }
    }),

    setUploadConfiguration: config => ({
        type: ConfigurationsActionTypes.SET_UPLOAD_CONFIGURATION,
        payload: config
    }),

    getLatestSchema: ({ serverId }) => ({
        type: ConfigurationsActionTypes.GET_LATEST_SCHEMA,
        payload: {
            serverId
        }
    }),

    getConfiguration: ({ serverId, hallId, config, isDetail, update = undefined }) => ({
        type: ConfigurationsActionTypes.GET_CONFIGURATION,
        payload: {
            serverId,
            hallId,
            config,
            isDetail,
            update
        }
    }),

    updateBasicConfig: ({
        config,
        isValid
    }: {
        config: any;
        isValid: boolean;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_BASIC_CONFIG,
        payload: {
            config,
            isValid
        }
    }),

    updateSettingsConfig: ({
        config,
        isValid
    }: {
        config: any;
        isValid: boolean;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_SETTINGS_CONFIG,
        payload: {
            config,
            isValid
        }
    }),

    updateAccountingConfig: ({
        config,
        isValid
    }: {
        config: any;
        isValid: boolean;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_ACCOUNTING_CONFIG,
        payload: {
            config,
            isValid
        }
    }),

    updateGroupsConfig: ({
        config,
        isValid,
        type
    }: {
        config: any;
        isValid: boolean;
        type?: string;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG,
        payload: {
            config,
            isValid,
            type
        }
    }),

    updateProgressivesConfig: ({
        config,
        isValid,
        groupType
    }: {
        config: any;
        isValid: boolean;
        groupType: GROUP_TYPE;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_PROGRESSIVES_CONFIG,
        payload: {
            config,
            isValid,
            groupType
        }
    }),

    updateGlobalJackpotConfig: ({
        config,
        isValid,
        groupType
    }: {
        config: any;
        isValid: boolean;
        groupType: GROUP_TYPE;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_GLOBAL_JACKPOT_CONFIG,
        payload: {
            config,
            isValid
        }
    }),

    updateSpecialPrizesConfig: ({
        config,
        isValid,
        groupType
    }: {
        config: any;
        isValid: boolean;
        groupType: GROUP_TYPE;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_CONFIG,
        payload: {
            config,
            isValid,
            groupType
        }
    }),

    updateMailSenderConfig: ({
        config,
        isValid
    }: {
        config: any;
        isValid: boolean;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_MAIL_SENDER_CONFIG,
        payload: {
            config,
            isValid
        }
    }),

    updateMegapotConfig: ({
        config,
        isValid
    }: {
        config: any;
        isValid: boolean;
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_MEGAPOT_CONFIG,
        payload: {
            config,
            isValid
        }
    }),

    clearConfiguration: () => {
        return {
            type: ConfigurationsActionTypes.CLEAR_CONFIGURATION
        };
    },

    clearGroupTypes: selectedType => {
        return {
            type: ConfigurationsActionTypes.CLEAN_GROUP_TYPES,
            payload: {
                selectedType
            }
        };
    },

    clearConfigurationSubmition: () => {
        return {
            type: ConfigurationsActionTypes.CLEAR_CONFIGURATION_STATE
        };
    },

    clearSchema: () => {
        return {
            type: ConfigurationsActionTypes.CLEAR_SCHEMA
        };
    },

    createConfiguration: ({ serverId }) => ({
        type: ConfigurationsActionTypes.CREATE_CONFIGURATION,
        payload: {
            serverId
        }
    }),

    editConfiguration: ({ serverId, config }) => ({
        type: ConfigurationsActionTypes.EDIT_CONFIGURATION,
        payload: {
            serverId,
            config
        }
    }),

    getHallBasicInfo: ({ serverId }) => ({
        type: ConfigurationsActionTypes.GET_HALL_BASIC_INFO,
        payload: {
            serverId
        }
    }),

    getGameInstances: ({ subsidiary, skip, top }) => ({
        type: ConfigurationsActionTypes.GET_GAME_INSTANCES,
        payload: {
            skip,
            top,
            subsidiary
        }
    }),

    getGameBundles: ({ subsidiary }) => ({
        type: ConfigurationsActionTypes.GET_GAME_BUNDLES,
        payload: {
            subsidiary
        }
    }),

    updateGroupByGameType: ({ newGroupsState }) => ({
        type: ConfigurationsActionTypes.UPDATE_GROUPS_BASED_ON_GAME_TYPES,
        payload: {
            newGroupsState
        }
    }),

    updateSpecialPrizesByBingoSettings: ({ newPrizesState, actionToValidIDMap }) => ({
        type: ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_BASED_ON_BINGO_SETTINGS,
        payload: {
            newPrizesState,
            actionToValidIDMap
        }
    }),

    selectGroupType: (groupType: GROUP_TYPE) => ({
        type: ConfigurationsActionTypes.SELECT_GROUP_TYPE,
        payload: {
            groupType
        }
    }),

    getSoundDecibels: () => ({
        type: ConfigurationsActionTypes.GET_DECIBELS
    }),

    getSoundPercentages: () => ({
        type: ConfigurationsActionTypes.GET_PERCENTAGE
    }),

    getSoundsServer: ({ serverId, subsidiary, version }) => ({
        type: ConfigurationsActionTypes.GET_SOUNDS_SERVER,
        payload: {
            serverId,
            subsidiary,
            version
        }
    }),

    setSoundSettingsOrder: ({ sounds, order }) => ({
        type: ConfigurationsActionTypes.REORDER_SOUNDS,
        payload: {
            sounds,
            order
        }
    }),

    updateSoundSettignsLevel: ({ gameInstanceId, soundGroupId, level }) => ({
        type: ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_LEVEL,
        payload: {
            gameInstanceId,
            soundGroupId,
            level
        }
    }),

    bulkUpdateSoundSettigns: ({ sounds }) => ({
        type: ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_BULK,
        payload: {
            sounds
        }
    }),

    updateSoundSettignsSubLevel: ({
        gameInstanceId,
        soundGroupId,
        sublevel
    }) => ({
        type: ConfigurationsActionTypes.UPDATE_SOUND_SETTINGS_SUB_LEVEL,
        payload: {
            gameInstanceId,
            soundGroupId,
            sublevel
        }
    }),

    getRTPProfiles: ({ subsidiary }) => ({
        type: ConfigurationsActionTypes.GET_RTP_PROFILES,
        payload: {
            subsidiary
        }
    }),

    setRTPProfilesOrder: ({ settings, order }) => ({
        type: ConfigurationsActionTypes.REORDER_RTP_PROFILES,
        payload: {
            settings,
            order
        }
    }),

    updateRTPProfile: ({ gameIdentifier, profile }) => ({
        type: ConfigurationsActionTypes.UPDATE_RTP_PROFILE,
        payload: {
            gameIdentifier,
            profile
        }
    }),

    updateRTPProfilesConfig: ({ isValid }) => ({
        type: ConfigurationsActionTypes.UPDATE_RTP_PROFILES_CONFIG,
        payload: {
            isValid
        }
    }),

    stepperIsEditing: () => ({
        type: ConfigurationsActionTypes.CONFIGURATION_VISITED_EDIT_MODE,
        payload: {}
    }),

    configSectionVisited: type => ({
        type: ConfigurationsActionTypes.VISIT_CONFIG_SECTION,
        payload: {
            type
        }
    }),

    getProgressivesRules: (subsidiary, isDetail, isDebug) => ({
        type: ConfigurationsActionTypes.GET_PROGRESSIVES_RULES,
        payload: {
            subsidiary,
            isDetail,
            isDebug
        }
    }),

    getRegions: subsidiary => ({
        type: ConfigurationsActionTypes.GET_REGIONS,
        payload: {
            subsidiary
        }
    }),

    getMailingLists: subsidiary => ({
        type: ConfigurationsActionTypes.GET_MAILING_LISTS,
        payload: {
            subsidiary
        }
    }),

    updateMailingListsConfiguration: (list, isValid) => ({
        type:ConfigurationsActionTypes.UPDATE_MAILING_CONFIG,
        payload:{
            type: "mailingList",
            isValid,
            list
        }
    }),

    getProductionServer: () => ({
        type: ConfigurationsActionTypes.GET_PRODUCTION_INFO
    }),

    getMegapotServerList: (provider,subsidiary) => ({
        type: ConfigurationsActionTypes.GET_MEGAPOT_SERVER_LIST,
        payload: {
            provider,
            subsidiary
        }
    }),
    getMegapotProvidersList: subsidiary => ({
        type: ConfigurationsActionTypes.GET_MEGAPOT_PROVIDERS_LIST
    }),
};
